'use strict';

var _ = require('lodash');

/**
 * Complex Legend Directive
 * @constructor
 */
var ComplexPullDownLegendDirective = function ComplexPullDownLegendDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/complex-pull-down-legend.html'),
    /**
     * @param {Object} scope
     * @param {ChartLegendItemDirective.scope.item[]} scope.legend - array of legend items
     * @param {string} [scope.legendTitle] - legend's title
     * @param {ChartLegendItemDirective.scope.item[]} [scope.staticLegend] - array of static legend items (ex. No Data)
     * @param {string} [scope.collapsible] - should legend be collapsible. If value other than 'true', will be false
     * @param {string} [scope.elementWidth] - element width (icon + name)
     * @param {string} [scope.itemMaxLength] - max number of letters in legend item, excess is truncated
     * @param {string} [scope.rowSize] - number of item in row
     */
    scope: {
      legend: '=',
      legendTitle: '=',
      staticLegend: '=',
      collapsible: '@',
      elementWidth: '=',
      separatorElementWidth: '=',
      itemMaxLength: '=',
      rowSize: '='
    },
    link: function link(scope, element) {
      var defaultElementWidth = 190;
      var panelContent = element.find('.legend-wrap');
      var panelContentHeight;
      var legendItemHeight = 20;
      var itemsMainPadding = 10;
      var titleElement = element.find('.legend-header');
      var seperatedRows = _.remove(scope.legend, function (item) {
        return item.separatorLeft;
      });
      scope.rowSize = scope.rowSize ? scope.rowSize : 4;
      function getCollapseHeight() {
        return Math.floor(legendItemHeight + 2 * itemsMainPadding) - panelContentHeight;
      }
      scope.initLegend = function () {
        if (_.isEmpty(scope.legend)) {
          return;
        }
        scope.displayWidth = scope.elementWidth || defaultElementWidth;
        scope.displaySeparatorWidth = scope.separatorElementWidth || defaultElementWidth;
        var titleHeight = titleElement.outerHeight() || 0;
        var rows = Math.ceil(scope.legend.length / scope.rowSize);
        function getLegendRows() {
          var rowSize = scope.rowSize;
          if (seperatedRows.length > 0) {
            rowSize -= 1;
          }
          return _.chain(scope.legend).reverse().chunk(rowSize).reverse().forEach(function (item) {
            item.reverse();
          }).value();
        }
        scope.legendInRows = getLegendRows();
        _.forEach(seperatedRows, function (item, index) {
          if (scope.legendInRows.length - 1 < index) {
            scope.legendInRows[index] = [];
          }
          scope.legendInRows[index].push(item);
        });
        if (scope.staticLegend && scope.legendInRows.length > scope.staticLegend.length) {
          var difference = scope.legendInRows.length - scope.staticLegend.length;
          for (var i = 0; i < difference; i++) {
            scope.staticLegend.unshift({
              label: '',
              id: '',
              fill: ''
            });
          }
        }
        if (rows === 1) {
          scope.displayRowSize = scope.legend.length;
          scope.displayCollapsible = false;
        } else {
          scope.displayRowSize = scope.rowSize;
          scope.displayCollapsible = scope.collapsible === 'true';
        }
        if (scope.displayCollapsible) {
          panelContentHeight = rows * (legendItemHeight + itemsMainPadding) + itemsMainPadding + titleHeight + 1;
          scope.legendIsCollapsed = false;
          scope.togglePanel();
        } else {
          panelContent.css('transform', 'translateY(0)');
        }
      };
      scope.togglePanel = function () {
        var height = scope.legendIsCollapsed ? 0 : getCollapseHeight() + 'px';
        panelContent.css('transform', 'translateY(' + height + ')');
        scope.legendIsCollapsed = !scope.legendIsCollapsed;
      };
      scope.$watch('legend', function (newVal, oldVal) {
        if (newVal !== oldVal && scope.legend) {
          scope.initLegend();
        }
      });
      scope.$on('trigger-tooltip:show', function (event, data) {
        scope.$broadcast('legend-tooltip-show:show', data);
      });
      scope.$on('trigger-tooltip:hide', function () {
        scope.$broadcast('legend-tooltip-show:hide');
      });
      scope.localMarketChangeHandler = function () {
        scope.marketChangeHandler(scope.selectedMarket);
      };
      if (scope.legend) {
        scope.initLegend();
      }
    }
  };
};
ComplexPullDownLegendDirective.$inject = [];
module.exports = ComplexPullDownLegendDirective;